export default __webpack_public_path__ + "static/media/qantas-group.0de778be.svg";